__turbopack_context__.v({
  "counterFixed": "HowItWorks-module-scss-module__8wD-oq__counterFixed",
  "counterMask": "HowItWorks-module-scss-module__8wD-oq__counterMask",
  "counterPinnedBottom": "HowItWorks-module-scss-module__8wD-oq__counterPinnedBottom",
  "timelinePictureWrap": "HowItWorks-module-scss-module__8wD-oq__timelinePictureWrap",
  "wrapper": "HowItWorks-module-scss-module__8wD-oq__wrapper",
});
